import { render, staticRenderFns } from "./BatchPrintModal.vue?vue&type=template&id=ca90ee24&"
import script from "./BatchPrintModal.vue?vue&type=script&lang=js&"
export * from "./BatchPrintModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports